import * as React from 'react';

const BallFieldSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="e0jkSXrKTmH1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 300 300"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    {...props}
  >
    <rect
      width={300}
      height={300}
      rx={0}
      ry={0}
      transform="translate(-.66354 0)"
      fill="#267f00"
      strokeWidth={0}
    />
    <ellipse
      rx={88.306772}
      ry={88.307985}
      transform="matrix(1.698624 0 0 1.595144 150.000003 187.356547)"
      fill="#164c00"
      stroke="#ffce00"
    />
    <ellipse
      rx={88.307985}
      ry={88.307985}
      transform="matrix(1.009175 0 0 0.948668 149.668231 224.079241)"
      fill="#7f6a00"
      strokeWidth={0}
    />
    <line
      x1={75}
      y1={75}
      x2={-75}
      y2={-75}
      transform="matrix(1.104726 0 0 1.104723 75 213)"
      fill="none"
      stroke="#fff"
      strokeWidth={3}
    />
    <line
      x1={-75}
      y1={75}
      x2={75}
      y2={-75}
      transform="translate(225.663541 213)"
      fill="none"
      stroke="#fff"
      strokeWidth={3}
    />
    <rect
      width={150.331771}
      height={150.331771}
      rx={0}
      ry={0}
      transform="matrix(1.310711 1.310711-.707107 0.707107-46.033971 92.629569)"
      fill="#164c00"
      strokeWidth={0}
    />
    <rect
      width={150.331771}
      height={150.331771}
      rx={0}
      ry={0}
      transform="matrix(1.310711-1.310711 0.707107 0.707107 125.824681 314.208534)"
      fill="#164c00"
      strokeWidth={0}
    />
    <rect
      width={14.151992}
      height={14.151992}
      rx={0}
      ry={0}
      transform="matrix(.608266 0.608266-.615042 0.615042 212.465995 217.162677)"
      fill="#fff"
      strokeWidth={0}
    />
    <rect
      width={14.151992}
      height={14.151992}
      rx={0}
      ry={0}
      transform="matrix(.608266 0.608266-.615042 0.615042 149.711511 158.900887)"
      fill="#fff"
      strokeWidth={0}
    />
    <rect
      width={14.151992}
      height={14.151992}
      rx={0}
      ry={0}
      transform="matrix(.608266 0.608266-.615042 0.615042 89.054918 217.637521)"
      fill="#fff"
      strokeWidth={0}
    />
    <rect
      width={14.293905}
      height={14.293905}
      rx={0}
      ry={0}
      transform="matrix(.362263 0.362263-.36095 0.36095 150.59383 286.549366)"
      fill="#fff"
      strokeWidth={0}
    />
    <rect
      width={14.293905}
      height={14.293905}
      rx={0}
      ry={0}
      transform="matrix(.718234 0 0 0.612719 145.481091 283.034844)"
      fill="#fff"
      strokeWidth={0}
    />
  </svg>
);

export default BallFieldSvg;
